const GlobalConstants = {
    examPassMark: 60,
    defaultResVideo: "Auto",
    featureFlagSprintThree: "dev",
    presentEnv: "dev"
}

export default GlobalConstants;
